<template>
    <div class="integrityIndex" v-if="ishow">
        <div class="wrapper-box">
            <div class="titles">
                评分：
                <span>{{((index1Score + index2Score) * 1.6 + index3Score * 0.4).toFixed(1)}}</span>
            </div>
            <div class="desc">(评分=(基础执业能力+执业规范度) * 1.6 + 游客满意度 * 0.4)</div>
            <div class="price-box">
                <div class="tags">基础执业能力: {{index1Score.toFixed(1)}}</div>
                <div class="tags">执业规范度：{{index2Score.toFixed(1)}}</div>
                <div class="tags">游客满意度：{{index3Score.toFixed(1)}}</div>
            </div>
            <div class="excel-title">近 6 个月评分变化</div>
            <div class="excel-box">
                <lineCharts style="height: 210px" :data="data" :color="color" :oneDecimal="true" :unit="'分'"/>
            </div>
        </div>
        <!-- tab切换区域 -->
        <div class="maincon-box">
            <tab :tabList="rankingTab" :name="'rankingTab'" @onSwitch="myPending" :ref="'rankTab'"></tab>
            <div class="score-box">
                <div class="num">{{tabScore.toFixed(1)}}</div>
                <div class="full">满分{{tabTotalScore}}分</div>
            </div>
            <rline class="bt15"></rline>
            <div class="standard-box">
                <div class="small-titles">得分明细</div>
                <div class="lists-box">
                    <div v-for="(items,index) in standardList" :key="index">
                        <div class="items-box line_bottom" :key="index">
                            <div class="item-top">
                              <div class="left-box">
                                <div class="title">
                                    {{items.scoreName}}
                                    <div class="dates">(满分{{items.maxScore.toFixed(1)}})</div>
                                </div>
                            </div>
                            <div class="right-box">
                                <div class="price-box">
                                    <div class="price">{{items.score.toFixed(1)}}</div>
                                </div>
                            </div>
                            </div>
                            <div
                                class="list"
                                v-for="(child, key) in items.children"
                                :key="index + '-' + key"
                                @click="$router.push({path:'/guide/material',query:{type:items.link,info: JSON.stringify(child)}})"
                            >
                                <div class="date">{{child.date.substring(0,10)}}</div>
                                <div class="type">
                                    {{child.awardLevel}}{{child.awardType}}
                                    <right></right>
                                </div>
                            </div>
                        </div>

                        <!-- <rline></rline> -->
                    </div>
                </div>
            </div>
        </div>
        <div class="space"></div>
        <div class="upload">
            <div
                class="btn"
                @click="$router.push({path:'/guide/uploadMaterial', query:{guideId: guideId}})"
            ><div class="label">上传评分材料</div></div>
        </div>
    </div>
</template>
<script>
    import api from '../../service/modules/guide';
    import right from './components/right';
    import tab from 'comps/tab';
    import lineCharts from '../guideSystem/components/LineCharts';
    import rline from '../travelAgency/components/line';
    import apimessage from '../../service/modules/message'
    export default {
        components: {
            tab,
            lineCharts,
            rline,
            right
        },

        data () {
            return {
                // 折线图
                data: [],
                color: '#FFF',
                rankingTab: ['基础执业能力', '执业规范度', '游客满意度'],
                currentIndex: 1,
                standardList: [],
                guideId: '',
                list1tab: [],
                list2tab: [],
                list3tab: [],
                tabIndex: 0,
                awardList: [],
                type: '',
                identification: '',
                ishow: false
            };
        },

        computed: {
            tabTotalScore () {
                let score = 0;
                this.standardList.forEach(element => {
                    score += element.maxScore;
                });
                return score;
            },
            tabScore () {
                let score = 0;
                this.standardList.forEach(element => {
                    score += element.score;
                });
                return score;
            },
            index1Score () {
                let score = 0;
                this.list1tab.forEach(element => {
                    score += element.score;
                });
                return score;
            },
            index2Score () {
                let score = 0;
                this.list2tab.forEach(element => {
                    score += element.score;
                });
                return score;
            },
            index3Score () {
                let score = 0;
                this.list3tab.forEach(element => {
                    score += element.score;
                });
                return score;
            }
        },

        watch: {},

        methods: {
            // 消息单条已读
            onMessageReadOne (isRead, id) {
                if (isRead === 'false') {
                    apimessage.messageReadOne({ messageId: id }).then(res => {
                        localStorage.setItem('messageId', id)
                    })
                }
            },
            test () {},
            redirectUrl () {
                let tmpArr = [...this.list1tab, ...this.list2tab, ...this.list3tab]
                for (let i = 0; i < tmpArr.length; i++) {
                    if (tmpArr[i].link === Number(this.type)) {
                        for (let y = 0; y < tmpArr[i].children.length; y++) {
                            if (tmpArr[i].children[y].identification === this.identification) {
                                localStorage.setItem('guideChild', JSON.stringify(tmpArr[i].children[y]))
                                // location.replace(`http://localhost:8080/#/guide/material?type=${this.type}`)
                                location.replace(`${this.globalApp.getSystemInfo().host}web/#/guide/material?type=${this.type}`)
                            }
                        }

                        break
                    }
                }
            },
            myPending (index) {
                this.tabIndex = index;
                this.standardList = [];
                if (index === 0) {
                    this.standardList = this.list1tab;
                } else if (index === 1) {
                    this.standardList = this.list2tab;
                } else if (index === 2) {
                    this.standardList = this.list3tab;
                }
            },
            getDiscussDetail () {
                api.guideDiscussDetail({ guideId: this.guideId }).then(res => {
                    this.list1tab = res.data.guideScore
                        ? res.data.guideScore.l1ProAbility[0].l2BasicAbility || []
                        : [];
                    this.list2tab = res.data.guideScore
                        ? res.data.guideScore.l1ProAbility[1]
                            .l2PractisingStandard || []
                        : [];
                    this.list3tab = res.data.guideScore
                        ? res.data.guideScore.l1TouristSatisfaction[0]
                            .l2TouristSatisfaction || []
                        : [];
                    this.awardList = res.data.award || [];
                    this.awardList.map(item => {
                        item.date = this.formatDate(item.awardTime);
                        return item;
                    });
                    this.list1tab.map(item => {
                        item.children = [];
                        if (item.scoreName === '表彰奖励或入选专家库、人才库') {
                            item.link = 0;
                            item.children = this.awardList;
                        }
                        if (item.scoreName === '参加公益活动') {
                            item.link = 1;
                            res.data.publicWelfare.map(element => {
                                element.awardLevel = element.eventName;
                                element.date = this.formatDate(element.eventTime);
                                return element;
                            });
                            item.children = res.data.publicWelfare || [];
                        }
                        return item;
                    });
                    this.list2tab.map(item => {
                        if (item.scoreName === '行政处罚及其他违规行为') {
                            res.data.punish.map(element => {
                                element.awardLevel = element.punishDetailType;
                                element.date = this.formatDate(element.punishTime);
                                return element;
                            });
                            item.children = res.data.punish;
                            item.link = 2;
                        }
                        if (item.scoreName === '其他不规范执业行为') {
                            res.data.disorder.map(element => {
                                element.awardLevel = element.disorderType;
                                element.date = this.formatDate(
                                    element.disorderTime
                                );
                                return element;
                            });
                            item.children = res.data.disorder;
                            item.link = 3;
                        }
                        return item;
                    });
                    if (this.type) {
                        this.redirectUrl()
                    } else {
                        this.$refs.rankTab.switchTab(0);
                    }
                });
            },
            // 时间戳转日期
            formatDate (timestamp) {
                var time = new Date(timestamp);
                var y = time.getFullYear();
                var m =
                    time.getMonth() + 1 < 10
                        ? '0' + (time.getMonth() + 1)
                        : time.getMonth() + 1;
                var d = time.getDate() < 10 ? '0' + time.getDate() : time.getDate();
                var h =
                    time.getHours() < 10 ? '0' + time.getHours() : time.getHours();
                var mm =
                    time.getMinutes() < 10
                        ? '0' + time.getMinutes()
                        : time.getMinutes();
                let date = y + '-' + m + '-' + d + ' ' + h + ':' + mm;
                return date;
            },
            getSixMonthData () {
                api.lastSixMouthData({ guideId: this.guideId }).then(res => {
                    if (res.ret === 0) {
                        this.data = [];
                        res.data.reverse();
                        res.data.forEach(item => {
                            this.data.push({
                                xAxis: item.date,
                                num: parseFloat(item.sumScore.toFixed(1))
                            });
                        });
                    }
                });
            }
        // getPunish(){

        // }
        },

        mounted () {
            // 有type时页面重定向到详情页
            if (this.$route.query.type) {
                this.ishow = false
            } else {
                this.ishow = true
            }
            this.type = this.$route.query.type || ''
            this.identification = this.$route.query.identification || ''
            this.guideId = this.$route.query.guideId;
            this.getDiscussDetail();
            this.getSixMonthData();
        },
        beforeRouteEnter (to, from, next) {
            next(vm => {
                // 通过 `vm` 访问组件实例
                if (from.path === '/guide/info') {
                    vm.guideId = vm.$route.query.guideId;
                    vm.getDiscussDetail();
                    vm.getSixMonthData();
                } else {
                // vm.tabChangeTwo(vm.tabIndex)
                }
            });
        },
        created () {
            let messageId = this.$route.query.messageId || ''
            let isRead = this.$route.query.isRead || 'true'
            this.onMessageReadOne(isRead, messageId)
        }
    };
</script>
<style scoped lang="less">
.integrityIndex {
    background: @base-bgcolor;
    min-height: 100%;
    .backnav-box {
        height: 44px;
        background: rgba(54, 179, 116, 1);
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;

        .back-icon {
            position: absolute;
            width: 10px;
            height: 16px;
            top: 14px;
            left: 20px;
        }

        .backnav-text {
            font-size: 16px;

            font-weight: 400;
            color: rgba(255, 255, 255, 1);
            line-height: 16px;
        }
    }

    .wrapper-box {
        background: rgba(54, 179, 116, 1);
        min-height: 317px;

        .titles {
            box-sizing: border-box;
            padding: 17px 12px 0 12px;
            font-size: 20px;

            font-family: PingFang SC, Arial, sans-serif;
            -webkit-font-smoothing: antialiased;
            font-weight: 500;
            color: rgba(255, 255, 255, 1);
            margin-bottom: 4px;

            span {
                font-size: 24px;
            }
        }

        .desc {
            box-sizing: border-box;
            padding: 0 12px;
            font-size: 12px;

            font-weight: 400;
            color: rgba(255, 255, 255, 1);
            line-height: 17px;
            margin-bottom: 4px;
        }

        .price-box {
            box-sizing: border-box;
            padding: 0 12px;
            display: flex;
            align-items: center;

            .tags {
                font-size: 12px;

                font-weight: 400;
                color: rgba(255, 255, 255, 1);
                line-height: 17px;
                margin-right: 7px;
                margin-bottom: 12px;
            }
        }

        .excel-title {
            box-sizing: border-box;
            padding: 0 12px;
            font-size: 12px;

            font-weight: 400;
            color: rgba(255, 255, 255, 1);
            line-height: 17px;
        }

        .excel-box {
            // padding-left: 12px;
            // padding-right: 12px;
        }
    }

    .maincon-box {
        width: 351px;
        min-height: 267px;
        background: rgba(255, 255, 255, 1);
        box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.04);
        border-radius: 3px;
        margin-top: -26px;
        margin-left: 12px;
        overflow: hidden;

        .data-card-tab {
            margin-left: 16px;
            margin-bottom: 26px;
        }

        .score-box {
            height: 72px;
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: center;

            .num {
                font-size: 24px;
                        font-family: PingFangSC-Regular, PingFang SC;
                        -webkit-font-smoothing: antialiased;
                font-weight: bold;
                color: rgba(54, 179, 116, 1);
            }

            .full {
                margin-top: 12px;
                font-size: 12px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: rgba(153, 153, 153, 1);
            }
        }

        .standard-box {
            .small-titles {
                box-sizing: border-box;
                padding: 0 16px;
                font-size: 12px;

                font-weight: 400;
                color: rgba(153, 153, 153, 1);
                line-height: 17px;
            }

            .lists-box {
                .list {
                    padding: 16px 0 0 0;
                    // &:last-child{
                    //   padding-bottom: 0;
                    // }

                    .date {
                        font-size: 12px;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                        color: rgba(102, 102, 102, 1);
                    }

                    .type {
                        margin-top: 12px;
                        font-weight: 400;
                        color: rgba(102, 102, 102, 1);
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                    }
                    &.material-item {
                        // border-bottom: 1px solid #eeeeee;
                        &:last-child {
                            border-bottom: 0;
                        }
                        &:last-child::after {
                            background: none;
                        }
                    }
                }

                .items-box {
                    display: flex;
                    flex-direction: column;
                    // align-items: center;
                    box-sizing: border-box;
                    padding: 16px;
                    // border-bottom: 1px solid #EEEEEE;
                    &.material {
                        padding: 16px 0;
                    }
                    &:last-child {
                        border-bottom: none;
                    }
                    .item-top{
                      display: flex;
                      align-items: center;
                    }

                    .left-box {
                        flex: 1;

                        .title {
                            font-size: 14px;
                            font-weight: 400;
                            color: rgba(51, 51, 51, 1);
                            line-height: 14px;

                            .dates {
                                font-size: 12px;
                                display: inline-block;
                                font-weight: 400;
                                color: rgba(153, 153, 153, 1);
                                line-height: 12px;
                            }
                        }
                    }

                    .right-box {
                        .price-box {
                            display: flex;
                            align-items: center;
                            // margin-bottom: 9px;

                            .price {
                                font-size: 12px;
                                font-family: PingFangSC-Regular, PingFang SC;
                                -webkit-font-smoothing: antialiased;
                                font-weight: bold;
                                color: #36b374;
                                line-height: 12px;
                                margin-right: 4px;
                            }

                            .img-right {
                                width: 12px;
                                height: 12px;
                            }
                        }

                        .status {
                            font-size: 12px;

                            font-weight: 400;
                            color: rgba(153, 153, 153, 1);
                            line-height: 12px;
                        }
                    }
                }
            }
        }

        .quality-box {
            .small-titles {
                box-sizing: border-box;
                padding: 0 16px;
                font-size: 12px;

                font-weight: 400;
                color: rgba(153, 153, 153, 1);
                line-height: 17px;
            }

            .info-box {
                display: flex;
                align-items: center;
                justify-content: space-between;
                box-sizing: border-box;
                padding: 24px 16px 16px 16px;

                .desc-box {
                    .person {
                        font-size: 14px;

                        font-weight: 400;
                        color: rgba(51, 51, 51, 1);
                        line-height: 14px;
                    }

                    .pricestand {
                        font-size: 14px;

                        font-weight: 400;
                        color: rgba(51, 51, 51, 1);
                        line-height: 14px;
                        margin: 8px 0;
                    }

                    .dates {
                        font-size: 12px;

                        font-weight: 400;
                        color: rgba(153, 153, 153, 1);
                        line-height: 12px;
                    }
                }

                .price-box {
                    height: 56px;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;

                    .price {
                        font-size: 24px;
                        font-family: PingFangSC-Regular, PingFang SC;
                        -webkit-font-smoothing: antialiased;
                        font-weight: bold;
                        color: rgba(54, 179, 116, 1);
                    }

                    .status {
                        font-size: 12px;

                        font-weight: 400;
                        color: rgba(153, 153, 153, 1);
                        line-height: 12px;
                    }
                }
            }

            .lists-box {
                .items-box {
                    height: 46px;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    box-sizing: border-box;
                    padding: 0 16px;
                    border-top: 1px solid #eee;

                    .namess {
                        font-size: 14px;

                        font-weight: 400;
                        color: rgba(51, 51, 51, 1);
                        line-height: 14px;
                    }

                    .price {
                        font-size: 12px;
                        font-family: PingFangSC-Regular, PingFang SC;
                        -webkit-font-smoothing: antialiased;
                        font-weight: bold;
                        color: rgba(255, 77, 77, 1);
                        line-height: 12px;
                    }
                }
            }
        }

        .experience-box {
            box-sizing: border-box;
            padding-top: 56px;
            text-align: center;

            .price {
                font-size: 24px;
                        font-family: PingFangSC-Regular, PingFang SC;
                        -webkit-font-smoothing: antialiased;
                font-weight: bold;
                color: rgba(54, 179, 116, 1);
                line-height: 24px;
                margin-bottom: 14px;
            }

            .desc {
                font-size: 12px;

                font-weight: 400;
                color: rgba(153, 153, 153, 1);
                line-height: 12px;
            }
        }
    }
    .space {
        height: 80px;
    }
    .upload {
        position: fixed;
        left: 0;
        bottom: 0;
        width: 100%;
        height: 60px;
        background: rgba(255, 255, 255, 1);
        display: flex;
        justify-content: center;
        align-items: center;
        box-shadow: 0px -2px 8px 0px rgba(0, 0, 0, 0.03);
        .btn {
            width: 345px;
            height: 40px;
            // text-align: center;
            // line-height: 40px;
            background: rgba(54, 179, 116, 1);
            border-radius: 3px;
            font-size: 17px;
            font-weight: 400;
            color: rgba(255, 255, 255, 1);
            // display: flex;
            // justify-content: center;
            // align-items: center;
            display: table;
            .label{
                display: table-cell;
                vertical-align: middle;
                text-align: center;
            }
        }
    }
}
</style>
